/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M13 14L9 18H15L11 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 2C7.74741 2 4.3 5.55187 4.3 9.93333C4.3 9.98093 4.30041 10.0284 4.30122 10.0758C2.40285 10.5786 1 12.3539 1 14.4667C1 16.9704 2.96995 19 5.4 19H17.5C20.5376 19 23 16.4629 23 13.3333C23 10.9231 21.5395 8.86433 19.4806 8.0452C18.6584 4.5753 15.6211 2 12 2Z"
				fill="currentColor"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M13 14L9 18H15L11 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.55893 9.53106C3.76319 4.9413 7.4446 1.25 12 1.25C15.8601 1.25 19.095 3.90344 20.1145 7.50352C22.268 8.52279 23.75 10.7563 23.75 13.3333C23.75 16.8559 20.9727 19.75 17.5 19.75H16.0784L16.4142 19.4142C16.9862 18.8422 17.1573 17.982 16.8478 17.2346C16.5382 16.4873 15.8089 16 15 16H13.8284L14.4142 15.4142C15.1953 14.6332 15.1953 13.3668 14.4142 12.5858C13.6332 11.8047 12.3668 11.8047 11.5858 12.5858L7.58579 16.5858C7.0138 17.1578 6.84268 18.018 7.15225 18.7654C7.32931 19.1928 7.64368 19.5352 8.03173 19.75H5.4C2.53479 19.75 0.25 17.3633 0.25 14.4667C0.25 12.225 1.61442 10.2944 3.55893 9.53106ZM13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697C13.2374 13.1768 12.7626 13.1768 12.4697 13.4697L8.46967 17.4697C8.25517 17.6842 8.191 18.0068 8.30709 18.287C8.42318 18.5673 8.69665 18.75 9 18.75H13.1893L10.4697 21.4697C10.1768 21.7626 10.1768 22.2374 10.4697 22.5303C10.7626 22.8232 11.2374 22.8232 11.5303 22.5303L15.5303 18.5303C15.7448 18.3158 15.809 17.9932 15.6929 17.713C15.5768 17.4327 15.3033 17.25 15 17.25H10.8107L13.5303 14.5303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C13.9084 2 15.6547 2.69815 17 3.85431M13 14L9 18H15L11 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M13 14L9 18H15L11 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.55893 9.53106C3.76319 4.9413 7.4446 1.25 12 1.25C15.8601 1.25 19.095 3.90344 20.1145 7.50352C22.268 8.52279 23.75 10.7563 23.75 13.3333C23.75 16.8559 20.9727 19.75 17.5 19.75H16.0784L16.4142 19.4142C16.9862 18.8422 17.1573 17.982 16.8478 17.2346C16.5382 16.4873 15.8089 16 15 16H13.8284L14.4142 15.4142C15.1953 14.6332 15.1953 13.3668 14.4142 12.5858C13.6332 11.8047 12.3668 11.8047 11.5858 12.5858L7.58579 16.5858C7.0138 17.1578 6.84268 18.018 7.15225 18.7654C7.32931 19.1928 7.64368 19.5352 8.03173 19.75H5.4C2.53479 19.75 0.25 17.3633 0.25 14.4667C0.25 12.225 1.61442 10.2944 3.55893 9.53106Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.5304 13.4697C13.8232 13.7626 13.8232 14.2374 13.5304 14.5303L10.8107 17.25H15C15.3034 17.25 15.5768 17.4327 15.6929 17.713C15.809 17.9932 15.7449 18.3158 15.5304 18.5303L11.5304 22.5303C11.2375 22.8232 10.7626 22.8232 10.4697 22.5303C10.1768 22.2374 10.1768 21.7626 10.4697 21.4697L13.1894 18.75H9.00002C8.69668 18.75 8.4232 18.5673 8.30711 18.287C8.19103 18.0068 8.25519 17.6842 8.46969 17.4697L12.4697 13.4697C12.7626 13.1768 13.2375 13.1768 13.5304 13.4697Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
